import { HitType, ProjectAchievementType, ProjectType } from '@types'

import { ImmerStateCreator, StatusAction } from '../store.type'

import {
  getHitsAchievementAction,
  GetHitsAchievementActionPayloadType,
  getProjectsAchievementAction,
  GetProjectsAchievementActionPayloadType,
  getProjectsAction,
  GetProjectsActionPayloadType,
} from './project.action'

/** StatusAction
 *
 ----------------------------- Lifecycle ----------------------------------
 IDLE => LOADING => SUCCEEDED or FAILED
 *
 */

export type ProjectSliceType = {
  /** selectors **/
  projectsFiltered: ProjectType[]
  projectsAchievementFiltered: ProjectAchievementType[]
  hitsFiltered: HitType[]
  /** actions **/
  /** PROJECT **/
  getProjectsAction: {
    call: (payload: GetProjectsActionPayloadType) => void
    status: StatusAction
  }
  /** CONTRIBUTORS **/
  getProjectsAchievementAction: {
    call: (payload: GetProjectsAchievementActionPayloadType) => void
    status: StatusAction
  }
  getHitsAchievementAction: {
    call: (payload: GetHitsAchievementActionPayloadType) => void
    status: StatusAction
  }
}

const projectSlice: ImmerStateCreator<ProjectSliceType> = (set) => ({
  projectsFiltered: [],
  projectsAchievementFiltered: [],
  hitsFiltered: [],
  /**  **/
  getProjectsAction: {
    call: (payload) => getProjectsAction(set)(payload),
    status: 'IDLE',
  },
  getProjectsAchievementAction: {
    call: (payload) => getProjectsAchievementAction(set)(payload),
    status: 'IDLE',
  },
  getHitsAchievementAction: {
    call: (payload) => getHitsAchievementAction(set)(payload),
    status: 'IDLE',
  },
})

export default projectSlice
